import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { BaseDashboardFiltersComponent } from '../base-dashboard-filters.component';
import { GaValidateService } from '../../../../../shared/formly/ga-validate.service';
import { GaMessageService } from '../../../../../shared/message/ga-message.service';
import { TranslationService } from '../../../../../shared/translation/translation.service';
import { ReportDataService } from '../../../../../shared/report/report-data.service';
import { ReportFiltersUtil } from '../../../../../shared/report/report-filters-util.service';
import { DashboardService } from '../../dashboard.service';
import { GaDeferredService } from '../../../../../shared/services/ga-deferred.service';
import { AuthService } from '../../../../../shared/services/auth/auth.service';
import { Override } from '../../../../../shared/app-decorators';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../../shared/services/formatting.service';
import { WebshopDataService } from '../../../../webshop/webshop-data.service';
import { DashboardDataService } from '../../../../../shared/report/dashboard-data.service';
import { DateType } from '../../../../../shared/services/date.util';

@Component({
  selector: 'sales-kpi-dashboard-filters',
  templateUrl: '../base-dashboard-filters.component.html'
})
export class SalesKpiDashboardFiltersComponent extends BaseDashboardFiltersComponent implements OnDestroy {
  private customerField:IExtraFieldConfigurationObject;
  private lamField:IExtraFieldConfigurationObject;
  private lamContactField:IExtraFieldConfigurationObject;
  private lamCompanyField:IExtraFieldConfigurationObject;
  private gbdmField:IExtraFieldConfigurationObject;

  constructor(
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    private webshopDataService:WebshopDataService,
    private dashboardDataService:DashboardDataService,
    validateService:GaValidateService,
    messageService:GaMessageService,
    translationService:TranslationService,
    reportDataService:ReportDataService,
    reportFiltersUtil:ReportFiltersUtil,
    dashboardService:DashboardService,
    deferredService:GaDeferredService,
    authService:AuthService,
    cdr:ChangeDetectorRef
  ) {
    super(validateService, messageService, translationService, reportDataService, reportFiltersUtil, dashboardService, deferredService, authService, cdr);
  }

  @Override(BaseDashboardFiltersComponent)
  public ngOnInit():void {
    super.ngOnInit();

    // init date models
    this.model.date_FROM = this.model.date_FROM || DateType.THIRTY_DAYS_AGO;
    this.model.date_TO = this.model.date_TO || DateType.TODAY;
  }

  public ngOnDestroy():void {
    this.dashboardDataService.clear();
  }

  @Override(BaseDashboardFiltersComponent)
  public fillFields():void {
    const promises:Array<Promise<any>> = [
      this.formlyService.fillField(this.customerField, this.webshopDataService.webshops()),
      this.formlyService.fillField(this.lamField, this.dashboardDataService.LAMs()),
      this.formlyService.fillField(this.lamContactField, this.dashboardDataService.LAMContacts()),
      this.formlyService.fillField(this.lamCompanyField, this.dashboardDataService.LAMCompanies()),
      this.formlyService.fillField(this.gbdmField, this.dashboardDataService.gbdms())
    ];

    Promise.all(promises)
      .then(this.setQueryFilters);
  }

  @Override(BaseDashboardFiltersComponent)
  public createFields():IExtraFieldConfigurationObject[] {
    return [
      this.customerField = this.formlyService.aSearch('customer', 'Customer')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatCompany)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.lamField = this.formlyService.aSearch('lam', 'LAM')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatName)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.lamContactField = this.formlyService.aSearch('lamContact', 'LAM Contact')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatName)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.lamCompanyField = this.formlyService.aSearch('lamCompany', 'LAM Company')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatName)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.gbdmField = this.formlyService.aSelect('gbdm', 'GBDM')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatContact)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.reportFiltersUtil.createDateRangeFilterFields(this.formlyService, 'Date', 'date')
    ];
  }
}